import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import SeguridadesLogic from '../../functions/logic/Seguridades'
import FormModal from '../../components/General/FormModal'
import Spiner from '../../components/General/Spiner'

const Roles = () => {
  const [spiner, setSpiner] = useState(false)
  const [isOpenModalform, setIsOpenModalForm] = useState(false)
  const [dataTableroForm, setDataTableroForm] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [saveType, setSaveType] = useState('I')
  const [header, setHeader] = useState('I')
  const userToken = localStorage.getItem('token')
  const [tableroId, setTableroId] = useState(0)
  const [data, setData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [totalRows, setTotalRows] = useState(0)

  const getRoles = useCallback(async (page, perPage) => {
    setSpiner(true)
    const resp = await SeguridadesLogic.rolesPhantomLogic(page, perPage)
    if(resp.success) {
      setData(resp.data)
      setOriginalData(resp.data) // Guardamos copia original para búsquedas locales
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
  }, [enqueueSnackbar]) 

  useEffect(() => {
    getRoles(1, 100) // Cargamos muchos datos para poder buscar localmente
  }, [getRoles])

  const columns = ['Codigo', 'Nombre', 'Descripcion', 'Fecha']

  const handleNew = async () => {
    cleanStorage()
    setSaveType("I")
    setTableroId(0)
    setSpiner(true)
    setDataTableroForm([])
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Nuevo Rol')
  }

  const cleanStorage = () => {
    localStorage.removeItem('codigoRol')
    localStorage.removeItem('nombreRol')
    localStorage.removeItem('descripcionRol')
  }

  const handleCloseModal = () => {
    setIsOpenModalForm(false)
    cleanStorage()
  }

  const handledSave = async (event) => {
    console.log(saveType)
    console.log(userToken)
    console.log(tableroId)
  }

  const handleEdit = (item) => {
    cleanStorage()
    setSaveType("E")
    setTableroId(item)
    setSpiner(true)
    setDataTableroForm(item)
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Editar Rol')
  }

  const handlePageChange = (page, perPage) => {
    getRoles(page, perPage)
  }

  const handleSearch = (item) => {
    const textoBusqueda = item.toLowerCase()
    const filtrado = originalData.filter((rol) =>
      rol.Nombre.toLowerCase().includes(textoBusqueda) ||
      rol.Codigo.toLowerCase().includes(textoBusqueda) ||
      rol.Descripcion?.toLowerCase().includes(textoBusqueda)
    )
    setData(filtrado)
  }

  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={'Guardar'}
        formData={dataTableroForm}
        handledSave={handledSave}
        opt={'roles'}
        modalWith={'md'}
      />

      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Seguridades</li>
                <li className="breadcrumb-item">roles</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data}
                    onNew={handleNew}
                    onEdit={handleEdit}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Roles
